let vm = null;
import store from "@/lobby_common/store";
export function sendRouterConfigThis(_this) {
  vm = _this;
}

const userPages = [
  {
    pc_path: "/user",
    h5_path: "/userCenter",
  },
  {
    pc_path: "/user/wallet",
    h5_path: "/user/hWallet",
  },
  {
    pc_path: "/user/gameRecord",
    h5_path: "/user/hGameRecord",
  },
  {
    pc_path: "/user/walletRecord",
    h5_path: "/user/hWalletRecord",
  },
  {
    pc_path: "/user/vip",
    h5_path: "/user/hVip",
  },
  {
    pc_path: "/user/notice",
    h5_path: "/user/hNoticeCenter",
  },
  {
    pc_path: "/user/distribution",
    h5_path: "/user/hDistribution",
  },
  {
    pc_path: "/reward",
    h5_path: "/user/hReward",
  },
  {
    pc_path: "/cooperation",
    h5_path: "/hCooperation",
  },
  {
    pc_path: "/promote",
    h5_path: "/user/hPromote",
  },
  {
    pc_path: "/task",
    h5_path: "/user/hTask",
  },
  {
    pc_path: "/policy/trading",
    h5_path: "/hpolicy/trading",
  },
  {
    pc_path: "/policy/user",
    h5_path: "/hpolicy/user",
  },
  {
    pc_path: "/policy/privacy",
    h5_path: "/hpolicy/privacy",
  },
  {
    pc_path: "/policy/service",
    h5_path: "/hpolicy/service",
  },
  {
    pc_path: "/user/givingGift",
    h5_path: "/user/hGivingGift",
  },
  {
    pc_path: "/events",
    h5_path: "/hEvents",
  },
  {
    pc_path: "/video",
    h5_path: "/video",
  },
  {
    pc_path: "/user/freeBet",
    h5_path: "/user/hFreeBet",
  },
];

export function findUserPagePath(path) {
  const page = userPages.find((p) => p.pc_path === path || p.h5_path === path);

  if (!page) return null;

  return store.getters.getIsMobile ? page.h5_path : page.pc_path;
}

export function redirectUserPage(type) {
  if (!vm) {
    return;
  }
  const path = vm?.$route.path;
  const routeObj = vm?.$route || {};
  if (type === "h5") {
    const obj = userPages.find((item) => item.pc_path === path);
    if (path.includes("/activityDetail/")) {
      vm.$router.replace({
        path: `/hactivityDetail/${routeObj.params?.id}`,
        query: { name: routeObj.query?.name },
      });
      return;
    }
    if (!obj) return false;
    const queryObj = routeObj.query || {};
    vm.$router.replace({
      path: obj.h5_path,
      query: { ...queryObj },
    });
  }
  if (type === "pc") {
    const obj = userPages.find((item) => item.h5_path === path);
    if (vm.$route.path === "/user/hAccountInfo") {
      vm.$router.replace("/user");
      return;
    }
    if (vm.$route.path === "/user/hCustomerService") {
      vm.$router.replace("/home");
      return;
    }
    if (vm.$route.path === "/user/hFeedBack") {
      vm.$router.replace("/user/notice");
      return;
    }
    if (path.includes("/hactivityDetail/")) {
      vm.$router.replace({
        path: `/activityDetail/${routeObj.params?.id}`,
        query: { name: routeObj.query?.name },
      });
      return;
    }
    // if (path.includes("/hHash")) {
    //   vm.$router.replace("/home");
    //   return;
    // }
    if (!obj) return false;
    const queryObj = routeObj.query || {};
    vm.$router.replace({
      path: obj.pc_path,
      query: { ...queryObj },
    });
  }
}
